var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{'header1': _vm.type === 'h1', 'header2': _vm.type === 'h2', 'header3': _vm.type === 'h3'}},[_c('div',{staticClass:"text"},[_vm._t("default")],2),_c('div',{staticClass:"line"}),_c('div',{staticClass:"icon"},[_vm._t("icon")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }